import { z } from 'zod';
import { Id, IsoDateTime, Currency } from './common.js';
import { BusinessType } from './business.js';

export const PricingModel = z.enum([
  'flat_per_merchant',
  'revenue_share',
  'per_message',
  'bulk_platform_deal',
  'direct_retail',
  'hybrid',
]);
export type PricingModel = z.infer<typeof PricingModel>;

export const PricingRule = z.object({
  rule_id: Id,
  platform_id: Id.nullable(),
  merchant_id: Id.nullable(),
  business_type: BusinessType.nullable(),
  model_type: PricingModel,
  parameters: z.record(z.unknown()),
  effective_from: IsoDateTime,
  effective_until: IsoDateTime.nullable(),
  created_by: z.string(),
  notes: z.string().default(''),
});
export type PricingRule = z.infer<typeof PricingRule>;

export const SubscriptionStatus = z.enum([
  'trialing',
  'active',
  'past_due',
  'paused',
  'cancelled',
  'expired',
]);

export const Subscription = z.object({
  subscription_id: Id,
  merchant_id: Id,
  business_type: BusinessType,
  platform_id: Id.nullable(),
  effective_pricing_rule_id: Id,
  status: SubscriptionStatus,
  credits_included: z.number().int().nonnegative(),
  credits_used: z.number().int().nonnegative(),
  credits_topup_balance: z.number().int().nonnegative().default(0),
  current_period_start: IsoDateTime,
  current_period_end: IsoDateTime,
  trial_ends_at: IsoDateTime.nullable(),
  started_at: IsoDateTime,
});
export type Subscription = z.infer<typeof Subscription>;

export const Invoice = z.object({
  invoice_id: Id,
  subscription_id: Id,
  merchant_id: Id,
  period_start: IsoDateTime,
  period_end: IsoDateTime,
  amount_cents: z.number().int().nonnegative(),
  currency: Currency,
  paid_at: IsoDateTime.nullable(),
  gateway_reference: z.string().nullable(),
  status: z.enum(['draft', 'open', 'paid', 'void', 'failed']),
  created_at: IsoDateTime,
});
